import log from "@/lib/calendesk-js-library/tools/log";
import store from "@/store/index";

export const trans = (key, attributes) => {
  const translations = { ...store.state.setup.translations };

  let trans = translations[key];

  if (trans) {
    if (attributes) {
      Object.keys(attributes).forEach((value) => {
        trans = trans.replace(`@{${value}}`, attributes[value]);
      });
    }

    return trans;
  }

  log.warn("Translation missing!", key);
  return key;
};

const getPluralIndex = (count, formsCount) => {
  if (formsCount === 1) return 0;
  if (formsCount === 2) return count === 1 ? 0 : 1;
  // 3 forms: Polish/Slavic rules
  const mod10 = Math.abs(count) % 10;
  const mod100 = Math.abs(count) % 100;
  if (count === 1) return 0;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return 1;
  return 2;
};

export const transPlural = (key, count, attributes) => {
  const translations = { ...store.state.setup.translations };

  let value = translations[key];

  if (value) {
    const forms = value.split("|");
    let selected = (forms[getPluralIndex(count, forms.length)] || forms[0]).trim();

    if (attributes) {
      Object.keys(attributes).forEach((attr) => {
        selected = selected.replace(`@{${attr}}`, attributes[attr]);
      });
    }

    return selected;
  }

  log.warn("Translation missing!", key);
  return key;
};
